import { render, staticRenderFns } from "./UICollapsed.vue?vue&type=template&id=46c6ffde&scoped=true"
import script from "./UICollapsed.vue?vue&type=script&lang=js"
export * from "./UICollapsed.vue?vue&type=script&lang=js"
import style0 from "./UICollapsed.vue?vue&type=style&index=0&id=46c6ffde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c6ffde",
  null
  
)

export default component.exports